import { useEffect, useState } from "react";
import {
  useGetOrderAreaChart,
  useGetOrderCountChart,
  useGetOrderRegisterCount,
} from "../../../Production/OrderArchive/Hook";
import { useGetKlischeTypeRatio, useGetOrderKlischeTypeRatio } from "./Hook";
import moment from "moment-jalaali";

const useChartOrderContainer = () => {
  const [dataLineChart, setDataLineChart] = useState([]);
  const [chartFilter, setChartFilter] = useState({ name: "mondth", enum: 1 });
  const [activeFilterType, setActiveFilterType] = useState(1);
  const [total, setTotal] = useState([]);
  const [customerFieldValue, setCustomerFieldValue] = useState(
    "00000000-0000-0000-0000-000000000000",
  );
  const [designerFiled, setDesignerFiled] = useState(
    "00000000-0000-0000-0000-000000000000",
  );
  const [KilscheThicknes, setKilscheThicknes] = useState(
    "00000000-0000-0000-0000-000000000000",
  );
  const [KlischeType, setKlischeType] = useState({
    KlischeType: "00000000-0000-0000-0000-000000000000",
  });
  const currentJalaliYear = moment().locale("en").format("jYYYY");
  const [year, setYear] = useState({ year: currentJalaliYear });
  const [month, setMonth] = useState({ month: 0 });
  const [day, setDay] = useState({ day: 0 });
  const changeActiveFilterType = (type) => {
    setActiveFilterType(type);
  };

  const tabHandler = (type) => {
    setChartFilter(() =>
      type === "day"
        ? { name: "day", enum: 0 }
        : type === "mondth"
          ? { name: "mondth", enum: 1 }
          : type === "year"
            ? { name: "year", enum: 2 }
            : { name: "all", enum: 3 },
    );
  };
  //*************************  Submit Api   ************************ */
  const { mutate, data } = useGetKlischeTypeRatio();

  const { mutate: orderMutate, data: orderData } =
    useGetOrderKlischeTypeRatio();

  const { mutate: registerCountMutate, data: registerData } =
    useGetOrderRegisterCount();

  //re-render
  useEffect(() => {
    // Base payloadfv
    const body = {
      chartReportTiming: chartFilter.enum,
      customerId: customerFieldValue,
      designerId: designerFiled,
      klischeThicknessId: KilscheThicknes.KilscheThicknes,
      year: year.year,
      month: month.month,
      day: day.day,
    };
    // Add KlischeType if selected
    if (
      KlischeType?.KlischeType &&
      KlischeType.KlischeType !== "00000000-0000-0000-0000-000000000000"
    ) {
      body.KlischeTypeId = KlischeType.KlischeType;
    }

    // Add KilscheThicknes if selected

    // Call API based on activeFilterType
    if (activeFilterType === 1) mutate(body);
    if (activeFilterType === 2) orderMutate(body);
    if (activeFilterType === 3) registerCountMutate(body);
  }, [
    chartFilter,
    activeFilterType,
    customerFieldValue,
    designerFiled,
    year,
    month,
    KlischeType,
    KilscheThicknes.KilscheThicknes,
  ]);

  //*************************  Fetch data    ************************ */
  const bindData = (data) => {
    setDataLineChart(data?.data?.data.items);
    setTotal([
      {
        count: data?.data?.data?.total,
        color: "#3592FB",
        title: "جمع کل",
        key: "total",
      },
    ]);
  };
  useEffect(() => {
    switch (activeFilterType) {
      case 1:
        bindData(data);
        break;
      case 2:
        bindData(orderData);
        break;
      case 3:
        bindData(registerData);
        break;
      default:
        break;
    }
  }, [data, orderData, registerData]);

  return {
    dataLineChart,
    setDataLineChart,
    chartFilter,
    data,
    orderData,
    activeFilterType,
    setActiveFilterType,
    registerData,
    total,
    changeActiveFilterType,
    customerFieldValue,
    setCustomerFieldValue,
    designerFiled,
    setDesignerFiled,
    tabHandler,
    year,
    setYear,
    month,
    setMonth,
    day,
    setDay,
    KlischeType,
    setKlischeType,
    KilscheThicknes,
    setKilscheThicknes,
  };
};
export default useChartOrderContainer;
